import React from 'react';

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

const Pagination = ({ pagination, onPageChange, pageSize, onPageSizeChange }) => {
  if (!pagination) return null;

  const { current_page, total_pages } = pagination;
  const showPager = total_pages > 1;

  if (!showPager && !onPageSizeChange) return null;

  const pages = Array.from({ length: total_pages }, (_, i) => i + 1).filter((p) => {
    if (total_pages <= 7) return true;
    return Math.abs(p - current_page) <= 2 || p === 1 || p === total_pages;
  });

  const items = [];
  pages.forEach((p, idx) => {
    if (idx > 0 && pages[idx - 1] !== p - 1) {
      items.push(
        <li key={`ellip-${p}`} className="page-item disabled">
          <span className="page-link">&hellip;</span>
        </li>
      );
    }
    items.push(
      <li key={p} className={`page-item ${p === current_page ? 'active' : ''}`}>
        <button type="button" className="page-link" onClick={() => onPageChange(p)}>
          {p}
        </button>
      </li>
    );
  });

  const pager = showPager ? (
    <nav aria-label="Page navigation" className="d-flex justify-content-center overflow-x-auto">
      <ul className="pagination mb-0 flex-nowrap">
        <li className={`page-item ${current_page <= 1 ? 'disabled' : ''}`}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(current_page - 1)}
            disabled={current_page <= 1}
          >
            <i className="ti ti-chevron-left" />
            <span className="d-none d-sm-inline ms-1">Previous</span>
          </button>
        </li>
        {items}
        <li className={`page-item ${current_page >= total_pages ? 'disabled' : ''}`}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(current_page + 1)}
            disabled={current_page >= total_pages}
          >
            <span className="d-none d-sm-inline me-1">Next</span>
            <i className="ti ti-chevron-right" />
          </button>
        </li>
      </ul>
    </nav>
  ) : null;

  if (!onPageSizeChange) {
    return <div className="mt-3">{pager}</div>;
  }

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
      <div className="d-flex align-items-center gap-2">
        <label htmlFor="page-size" className="form-label small mb-0 text-muted">Rows</label>
        <select
          id="page-size"
          className="form-select form-select-sm"
          style={{ width: 'auto' }}
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>
      {pager}
    </div>
  );
};

export default Pagination;
